<template>
      
    <div>
        <a-form layout="horizontal" :label-col="labelCol" :wrapper-col="wrapperCol"  ref="ruleForm" labelAlign="right" :model="form" :rules="rules">
            <!--可编辑区域 start-->
            <div  class="hidden">
                <!-- <div > -->
                <a-form-item label="主键ID" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入主键ID" />
                </a-form-item>
                <a-form-item label="项目ID" name="projectId">
                    <a-input v-model:value="form.projectId" placeholder="请输入项目ID" />
                </a-form-item>
            </div>

            <a-row :gutter="20">
                <a-col :span="12">
                    <a-form-item label="应用行业" name="applicationIndustry">
                        <a-input v-model:value="form.applicationIndustry" placeholder="请输入应用行业" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="预期成果(可多选)" name="expectedResults">
                        <DictSelect :multiple="true" v-model:value="form.expectedResults" :dict-name="'expectedResults'" style="margin: -5px 0"
                          placeholder="请选择"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="预期专利(可多选)" name="expectedPatent">
                        <DictSelect :multiple="true" v-model:value="form.expectedPatent" :dict-name="'expectedPatent'" style="margin: -5px 0"
                          placeholder="请选择"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="简要说明" name="briefDescription">
                        <a-textarea v-model:value="form.briefDescription" placeholder="请输入简要说明" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="立项背景" name="projectBackground">
                        <a-textarea v-model:value="form.projectBackground" placeholder="请输入立项背景" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="12">
                    <a-form-item label="流程id" name="processId">
                        <a-input v-model:value="form.processId" placeholder="请输入流程id" />
                    </a-form-item>
                </a-col> -->
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
    </div>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {projectImportantResearch} from "@/api/TechnologieprojekteApply";
import DictSelect from "@/components/other/DictSelect";
// import YearPicker from "@/components/form/datePicker/YearPicker";
import {postAction,postJson} from "@/utils/http/service";
import {filterObj} from "@/utils/util";
import store from '@/store';


export default {
    name: "项目基本信息",
    components: {DictSelect},

    mixins: [formMixin],
    data() {
        return {
            oneClassification: null,
            labelCol: { span: 8 },
            wrapperCol: { span: 14 },
            form: {
                id: null,
                projectId: this.$route.query.id,
                applicationIndustry: null,
                expectedResults: null,
                expectedPatent: null,
                briefDescription: null,
                projectBackground: null,
            },
            rules: {
                id: [],
                projectId: [],
                applicationIndustry: [
                    dataCheck.required({}),
                ],
                expectedResults: [
                    dataCheck.required({}),
                ],
                expectedPatent: [
                    dataCheck.required({}),
                ],
                briefDescription: [
                    dataCheck.required({}),
                ],
                projectBackground: [
                    dataCheck.required({}),
                ],
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                return projectImportantResearch.saveOrUpdate
            }
        },
    mounted() {
        if(this.$route.query.id){
            this.onEdit()
        }
        this.oneClassification=this.$route.query.oneClassification
    },
    methods: {
        onEdit() {
            this.getAction({
                url: projectImportantResearch.detailByProject,
                params: { 
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                 }
            }).then(res => {
                if(res){
                    this.form = res
                    this.$parent.$parent.$parent.$parent.postData(res.oneClassification,res.id)
                }
            })
        },
        /*提交表单操作*/
        onSubmit(anres) {
            if(anres){
                this.form.projectId = anres
            }
            console.log(anres,'得到了吗')
            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {
                        this.confirmLoading = true;
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                            let action;
                        /*后台请求*/
                        if(this.submitType == 'json'){
                            action = postJson({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }else{
                            action=  postAction({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }
                        action.then((res) => {
                            this.$parent.$parent.postData(res.data.classification,res.data.projectId)
                            this.confirmLoading = false;
                            this.$notification.success({
                                message: '提示',
                                description: res.msg || '操作成功',
                            });
                            if (this.onSuccessFn) {
                                this.onSuccessFn(res);
                            }
                            if (this.isModal) {
                                this.$emit('finish');
                                this.onClose();
                            }
                        }).catch(() => {
                            this.confirmLoading = false;
                        })
                    })
                    .catch(error => {
                        if(error.errorFields.length){
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                            this.$parent.$parent.$parent.$parent.errorSet()
                        }
                        window.console.log('error', error);
                    });
            }
        },
    },
}
</script>
<style scoped lang="less">
:deep(.ant-modal-body) {
    height:100vh!important;
    max-height: 100vh!important;
     }
</style>
